import { render, staticRenderFns } from "./DetailRow.vue?vue&type=template&id=d5b72520&scoped=true&"
import script from "./DetailRow.vue?vue&type=script&lang=ts&"
export * from "./DetailRow.vue?vue&type=script&lang=ts&"
import style0 from "./DetailRow.vue?vue&type=style&index=0&id=d5b72520&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b72520",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
